// extracted by mini-css-extract-plugin
module.exports = {"selectionCheckbox":"selectionCheckbox--22de8","selectionCellsContainer":"selectionCellsContainer--a64a3"};